import * as types from './actionTypes';

export const getSalesAgentList = (payload) => ({
  type: types.GET_SALES_AGENT_LIST,
  payload,
});

export const setSalesAgentList = (payload) => ({
  type: types.SET_SALES_AGENT_LIST,
  payload,
});

export const createSalesAgent = (payload) => ({
  type: types.CREATE_SALES_AGENT,
  payload,
});

export const createSalesAgentSuccess = (payload) => ({
  type: types.CREATE_SALES_AGENT_SUCCESS,
  payload,
});

export const createSalesAgentFailure = (payload) => ({
  type: types.CREATE_SALES_AGENT_FAILURE,
  payload,
});

export const getSalesAgentDetails = (payload) => ({
  type: types.GET_SALES_AGENT_DETAILS,
  payload,
});

export const setSalesAgentDetails = (payload) => ({
  type: types.SET_SALES_AGENT_DETAILS,
  payload,
});

export const updateSalesAgentStatus = (payload) => ({
  type: types.UPDATE_SALES_AGENT_STATUS,
  payload,
});

export const updateSalesAgentStatusSuccess = (payload) => ({
  type: types.UPDATE_SALES_AGENT_STATUS_SUCCESS,
  payload,
});

export const setStatusUpdateSuccess = (payload) => ({
  type: types.SET_STATUS_UPDATE_SUCCESS,
  payload,
});

export const updateSalesAgent = (payload) => ({
  type: types.UPDATE_SALES_AGENT,
  payload,
});

export const updateSalesAgentSuccess = (payload) => ({
  type: types.UPDATE_SALES_AGENT_SUCCESS,
  payload,
});

export const updateSalesAgentFailure = (payload) => ({
  type: types.UPDATE_SALES_AGENT_FAILURE,
  payload,
});

export const clearSalesAgentError = () => ({
  type: types.CLEAR_SALES_AGENT_ERROR,
});

export const getSalesAgentMerchants = (payload) => ({
  type: types.GET_SALES_AGENT_MERCHANTS,
  payload,
});

export const setSalesAgentMerchants = (payload) => ({
  type: types.SET_SALES_AGENT_MERCHANTS,
  payload,
});

export const clearSalesAgentView = () => ({
  type: types.CLEAR_SALES_AGENT_VIEW,
});
